// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order.
//
// Saklaw ng file na ito: pure date/time availability math — walang DOM
// dependency (isDateSelectable, isSlotAvailable, getCutoffTime,
// getMinSelectableDate, getSlotStatus, atbp.).
//
// Hakbang 3 (2026-09-02): pure renderer na ito ng server-provided
// state.availability (ang availabilityWindow mula sa /apps/schedule-rules —
// {today, minDate, maxDate, cutoffAt, dates}) — WALA nang lokal na
// cutoff/prep-hours na computation. Ang dayjs dito ay formatter/date-math
// helper na lang (date increments, timezone display), hindi na pinagmumulan
// ng availability truth. Bago dumating ang unang successful fetch
// (state.availability === null), lahat ng function dito ay fail-safe sa
// "blocked/unavailable" — sinasadya ito para lumabas na disabled/empty shell
// ang widget imbes na gumamit ng anumang stale/guessed na default.
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const CONFIG = DP.CONFIG;
  const state = DP.state;

  function getNowPH() {
    return dayjs().tz(CONFIG.timezone);
  }

  // Iisa lang ang cutoff sa buong window (parehong same-day cutoff), kaya
  // hindi na kailangan ng dateStr para makapag-compute — pinapanatili lang
  // ito bilang param para hindi masira ang existing call sites.
  function getCutoffTime(dateStr) {
    if (!state.availability || !state.availability.cutoffAt) return null;
    const cutoff = dayjs(state.availability.cutoffAt).tz(CONFIG.timezone);
    return cutoff.isValid() ? cutoff : null;
  }

  function getMinSelectableDate(now = getNowPH()) {
    return state.availability ? state.availability.minDate : now.format("YYYY-MM-DD");
  }

  function getMaxSelectableDate(minDateStr) {
    return state.availability ? state.availability.maxDate : minDateStr;
  }

  // Walang entry sa window.dates para sa isang petsa = hindi ito bookable
  // (mas ligtas na default kaysa ipagpalagay na open).
  function isDateBlocked(dateStr) {
    const entry =
      state.availability && state.availability.dates ? state.availability.dates[dateStr] : undefined;
    return entry ? !!entry.dateBlocked : true;
  }

  // Per-slot na desisyon batay lang sa sariling fields ng slot mismo — walang
  // date-level check dito (dateBlocked/window range), sadyang hiwalay iyon
  // (tingnan isDateSelectable/getSlotStatus).
  function isSlotAvailable(dateStr, slotValue, now = getNowPH()) {
    const entry =
      state.availability && state.availability.dates ? state.availability.dates[dateStr] : undefined;
    const slot = entry && entry.slots ? entry.slots[slotValue] : undefined;
    if (!slot) return false;

    if (!slot.available || slot.blocked) return false;
    if (slot.lastOrderAt == null) return true;

    return Date.now() < Date.parse(slot.lastOrderAt);
  }

  function isDateSelectable(dateStr, now = getNowPH()) {
    if (!dateStr || !state.availability) return false;

    const { minDate, maxDate, dates } = state.availability;
    if (dateStr < minDate || dateStr > maxDate) return false;
    if (isDateBlocked(dateStr)) return false;

    const entry = dates[dateStr];
    if (!entry || !entry.slots) return false;

    return Object.keys(entry.slots).some((slotValue) => isSlotAvailable(dateStr, slotValue, now));
  }

  // Ang pinaka-maagang petsa (simula sa window.minDate) na may kahit isang
  // available slot — hindi kinukwenta ang blocked/full/cutoff-passed na petsa
  // sa pagitan. Ginagamit ng render loop (delivery-picker-render-time-slots.js)
  // para i-scope ang "Closes soon" badge dito lang, hindi sa kahit anong
  // petsang tinitingnan (2026-09-01 — flowerchimp.com.ph reference: ang
  // urgency badge nila ay lumalabas lang sa nearest-bookable date, hindi sa
  // bawat petsang bina-browse; solusyon ito sa maling literal na
  // pangako ng "Closes soon" sa mga advance order na 20 araw pa).
  function getNearestBookableDate(now = getNowPH()) {
    if (!state.availability) return null;

    const { minDate, maxDate } = state.availability;
    let candidate = minDate;

    while (candidate <= maxDate) {
      if (isDateSelectable(candidate, now)) return candidate;
      candidate = dayjs.tz(candidate, "YYYY-MM-DD", CONFIG.timezone).add(1, "day").format("YYYY-MM-DD");
    }

    return null;
  }

  function getSlotStatus(dateStr, slotValue, now = getNowPH()) {
    const status = { cutoffPassed: false, closesSoon: false, full: false };
    if (!dateStr || !slotValue || !state.availability) return status;

    const { minDate, maxDate, dates } = state.availability;

    // Locked precedence: dateBlocked → outside window/before minDate →
    // blocked → cutoff. Ang una at pangalawang tuntunin dito ay hindi
    // dapat mag-badge — nakikita na ang mga iyon bilang "not selectable"
    // sa ibang lugar ng UI (date strip/calendar), hindi kailangan ng
    // per-slot na label pa.
    const entry = dates[dateStr];
    if (!entry || entry.dateBlocked) return status;
    if (dateStr < minDate || dateStr > maxDate) return status;

    const slot = entry.slots ? entry.slots[slotValue] : undefined;
    if (!slot) return status;

    // `blocked` = admin/capacity verdict lang, HINDI time-based (server:
    // delivery-availability.ts isSlotBlocked/isSlotAtCapacity) — kaya ito
    // lang, hindi `!slot.available`, ang tamang "Full" trigger. Ang
    // `available` naman ay ang FULL time-aware gate (kasama na ang
    // blocked/capacity/window/cutoff/prep) noong huling fetch — luma na ito
    // sa sandaling lumipas ang oras, kaya ang cutoff ay laban sa
    // `lastOrderAt` vs Date.now() (real-time), hindi sa `available` mismo.
    // MAHALAGA: ang today-past-cutoff ay HINDI dumadaan dito bilang "Full" —
    // bumabagsak ito sa cutoff check sa ibaba bilang plain "Cut-off".
    if (slot.blocked) {
      status.full = true;
      return status;
    }

    if (slot.lastOrderAt && Date.now() >= Date.parse(slot.lastOrderAt)) {
      status.cutoffPassed = true;
    }

    return status;
  }

  DP.getNowPH = getNowPH;
  DP.getCutoffTime = getCutoffTime;
  DP.getMinSelectableDate = getMinSelectableDate;
  DP.getMaxSelectableDate = getMaxSelectableDate;
  DP.isDateBlocked = isDateBlocked;
  DP.isDateSelectable = isDateSelectable;
  DP.isSlotAvailable = isSlotAvailable;
  DP.getNearestBookableDate = getNearestBookableDate;
  DP.getSlotStatus = getSlotStatus;
})();
